import { Toast } from "primereact/toast";
import { useRef, useState } from "react";

import { IVendorCompanyMast } from "../../models/VendorCompanyMast";
import { EmptyVendorCompany } from "./EmptyVendorCompany";
import { Form } from "./Form";
import { Table } from "./Table";
import { IPermissionProps } from "../../models/Login";

export interface IModel {
    open: boolean,
    singleData: IVendorCompanyMast
}

export const VendorCompanyMast = (permissions: IPermissionProps) => {

    const [modal, setModal] = useState({ singleData: EmptyVendorCompany, open: false } as IModel);
    const [reload, setReload] = useState(false);
    const toast = useRef<any>(null);

    const hideDialog = () => {
        setModal({ singleData: EmptyVendorCompany, open: false })
    };


    return (
        <>
            <Form singleData={modal.singleData} open={modal.open} hideDialog={hideDialog} toast={toast} reload={reload} setReload={setReload}></Form>
            <Table permissions={permissions} setModal={setModal} toast={toast} reload={reload}></Table>
            <Toast ref={toast} />
        </>
    );
}
